import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup() {
  return <section className="py-12 px-6 max-w-5xl mx-auto" data-id="element-50">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-100 bg-white" data-id="element-51">
        <img src="https://cdn.magicpatterns.com/uploads/m5bDjhFiTqFrD3No5j3HTa/image_page.png" alt="The Social Cheat Codes Product Mockup" className="w-full h-auto object-cover" data-id="element-52" />
      </motion.div>
    </section>;
}